import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import cx from "classnames"
import styles from "@/components/core/Checkbox/index.module.scss"
import checkboxTick from "@/public/icons/checkbox-tick.svg"
import { getConfig } from "@/constants/config"

const Checkbox = props => {
  const [config, setConfig] = useState({})
  const {
    textClassName = "checkbox_default",
    inline = false,
    inputRef = null,
  } = props
  useEffect(() => {
    getConfig()
      .then(config => {
        setConfig(config?.general)
      })
      .catch(err => console.log(err))
  }, [])
  const handleCheck = e => {
    if (e.keyCode === 32 || e.keyCode === 13) {
      e.preventDefault()
      e.target.click()
    }
  }

  return (
    <div
      className={`${styles.checkboxWrapper}${
        inline ? ` ${styles.inlineCheckbox}` : ""
      }`}
    >
      <label
        htmlFor={props.id}
        className={cx({
          checkbox: true,
          "checkbox--swatch": props.swatch,
          "checkbox--black": props.type === "black",
        })}
      >
        <input
          data-gbh-data-layer={props.analyticsData || null}
          data-gbh-data-layer-custom={props.analyticsDataCustom || null}
          className={props.analyticsData ? "gbh-data-layer" : ""}
          type="checkbox"
          name={props.id}
          id={props.id}
          ref={inputRef}
          onChange={e => props.onChange(e)}
          onKeyDown={handleCheck}
          checked={props.checked}
          disabled={props.disabled}
          aria-label={props.checkBoxAria ?? props.aria}
          data-testid={props?.dataTestId ?? ""}
        />
        <span className="checkbox__border">
          <div className="checkbox__marker">
            {checkboxTick?.src ? (
              <img
                className="checkbox__marker-icon"
                src={checkboxTick.src}
                alt="checkbox-icon"
                aria-hidden={true}
              />
            ) : null}
          </div>
        </span>
        {config?.swatchUrl ? (
          <div
            className="checkbox__swatch"
            style={{
              backgroundImage: `url("${config?.swatchUrl}${props?.swatch}?$PLPSwatch_Mobile50$")`,
            }}
          ></div>
        ) : null}
        <span className={textClassName}>{props.value}</span>
      </label>
    </div>
  )
}

export default Checkbox

Checkbox.propTypes = {
  textClassName: PropTypes.string,
  checked: PropTypes.bool,
  id: PropTypes.string,
  inline: PropTypes.bool,
  checkBoxAria: PropTypes.string,
  aria: PropTypes.string,
  swatch: PropTypes.string,
  type: PropTypes.string,
  analyticsData: PropTypes.object,
  analyticsDataCustom: PropTypes.object,
  disabled: PropTypes.bool,
  value: PropTypes.bool,
  onChange: PropTypes.func,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
}
